import { useQuery } from '@tanstack/react-query'
import { UseBaseQueryOptions } from '@tanstack/react-query'
import { getPlayerProviderStats } from '../../services'
import { PlayerQueryKeys } from '@/modules/manage-player/keys'
import type {
	GetPlayerProviderStatsRequest,
	GetPlayerProviderStatsResponse,
} from '@/modules/manage-player/type'

export default function useQueryGetPlayerProviderStats(
	params: GetPlayerProviderStatsRequest,
	props?: UseBaseQueryOptions<GetPlayerProviderStatsResponse>,
) {
	return useQuery({
		queryKey: [PlayerQueryKeys.GetPlayerProviderStats, params],
		queryFn: () => getPlayerProviderStats(params),
		enabled: Boolean(params.playerId),
		...props,
	})
}
